import React from 'react';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiHelpCircle, FiCheckCircle, FiMinusCircle, FiAlertCircle } = FiIcons;

// Updated thresholds for 1-7 scale
// High: >= 6 (approx top 20-25%)
// Mid: >= 4 (mid range)
// Low: < 4
const QuestionDetails = ({ element, questions, scores }) => {
  const getScoreIcon = (score) => {
    if (score >= 6) return { icon: FiCheckCircle, color: 'text-green-500' };
    if (score >= 4) return { icon: FiMinusCircle, color: 'text-yellow-500' };
    return { icon: FiAlertCircle, color: 'text-red-500' };
  };

  const getScoreColor = (score) => {
    if (score >= 6) return 'text-green-600 bg-green-50';
    if (score >= 4) return 'text-yellow-600 bg-yellow-50';
    return 'text-red-600 bg-red-50';
  };

  const elementQuestions = questions || [];

  return (
    <div>
      {/* Title and Description removed as requested - handled by parent component header */}

      {elementQuestions.length === 0 ? (
        <div className="text-center py-6 text-gray-500">
          <SafeIcon icon={FiHelpCircle} className="w-8 h-8 mx-auto mb-2 text-gray-400" />
          <p>Keine Fragen für dieses Element vorhanden</p>
        </div>
      ) : (
        <div className="space-y-3">
          {elementQuestions.map((question) => {
            const score = scores[question.id] || 0;
            const { icon: ScoreIcon, color } = getScoreIcon(score);
            
            return (
              <div key={question.id} className="border border-gray-200 rounded-lg p-4">
                <div className="flex items-start justify-between">
                  <div className="flex-1">
                    <p className="text-sm text-gray-900 font-medium">
                      {question.text}
                    </p>
                  </div>
                  <div className="ml-4 flex items-center space-x-2">
                    <SafeIcon icon={ScoreIcon} className={`w-4 h-4 ${color}`} />
                    <span className={`text-sm font-medium px-2 py-1 rounded ${getScoreColor(score)}`}>
                      {score.toFixed(1)}
                    </span>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default QuestionDetails;